<template>
  <div class="container">
    <div class="pcinfo">
      <div class="tits">{{ $t('auth').low }}</div>
      <div class="content">
        <van-field v-model="RealName" :label="`${$t('auth').userName}:`" :border="false" :placeholder="$t('auth').tips1"
          input-align="right" />
        <van-field v-model="IdCard" :label="`${$t('auth').IDNumber}:`" :border="false" :placeholder="$t('auth').tips2"
          input-align="right" />
        <div class="btn" @click="handleSub">{{ $t('auth').qrz }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
export default {
  components: {
  },
  data() {
    return {
      RealName: '',
      IdCard: ''
    }
  },
  methods: {
    async handleSub() {
      if (!this.RealName) {
        this.$toast(this.$t('auth').tips1)
        return false
      }
      if (this.IdCard === '') {
        this.$toast(this.$t('auth').tips2)
        return false
      }
      const form = {
        IdCard: this.IdCard,
        RealName: this.RealName
      }
      await userApi.IdentityAuthentication(form)
      this.$toast(this.$t('moneyAddr').success)
      setTimeout(() => {
        this.$router.go(-1)
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding: 50px 0;
  width: 100%;

  .pcinfo {
    margin: 0 auto;
    max-width: 700px;
  }

  .tits {
    font-size: 20px;
    font-weight: bold;
  }

  .content {
    margin: 10px 0;
    padding: 10px;
    border-radius: 4px;
    background: #17181e;

    .van-field {
      background: transparent;

      & /deep/ .van-field__control,
      & /deep/ .van-field__label {
        color: #fff;
        font-size: 12px;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px auto 0;
      height: 40px;
      border-radius: 18px;
      width: 100%;
      background: #f2ba18;
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>
